<script lang="ts">
    import { ProfileService } from '../../../modules/toolsApi/sites/services/profile-service'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZContainerCol from '../../_common/z/z-container-col.svelte'
    import { faSave } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()

    export let service: ProfileService = new ProfileService()

    // quem exibe esta imagem é o app do cliente final, sem login: o upload precisa ir para o
    // bucket público (presign={false}), senão a URL gravada só abriria com token.
    // no type="file" o "options" não é uma lista de escolhas: cada value vira um padrão do
    // atributo accept. o label existe só para satisfazer o tipo da prop, ninguém o exibe.
    const imageAccept = [{ value: 'image/*', label: 'Imagens' }]

    // o mesmo par usado no toggle do aplicativo, para não inventar um terceiro vocabulário de status
    let active: boolean = service.status === undefined || service.status === 100

    function sendSuccess() {
        if (!service.headline) {
            window.error('Informe ao menos o título do serviço')
            return
        }
        service.status = active ? 100 : 70
        dispatch('success', service)
    }
</script>

<div class="root">
    <Zact>
        <div class="spacer" />
        <Zbutton color="primary" icon={faSave} label="Salvar" on:click={sendSuccess} />
    </Zact>
    <Zframe class="m-3" title="Serviço">
        <ZContainer gapRow="8px" gapCol="8px">
            <Zinput size={6} sizeM={12} label="Imagem" type="file" presign={false} options={imageAccept} bind:value={service.image} />
            <Zinput size={6} sizeM={12} label="Título" type="text" bind:value={service.headline} />
            <Zinput size={12} label="Subtítulo" type="text" bind:value={service.subheadline} />
            <Zinput size={12} label="Descrição" rows="8" type="textarea" bind:value={service.content} />
            <Zinput size={12} skin="outline" label="Serviço visível no aplicativo" type="toggle" bind:value={active} />
            <ZContainerCol size={12}>
                <div class="text-muted">
                    O título, o subtítulo e a imagem aparecem no card da tela inicial. A descrição aparece apenas quando o cliente abre o serviço.
                </div>
            </ZContainerCol>
        </ZContainer>
    </Zframe>
</div>
